module.exports = __webpack_public_path__ + "media/images/index/care_01_list-b2029902a764e6098d1ad191523068eb.jpg";